import { Box, Typography, BoxProps } from "@mui/material";

interface StatCardProps extends BoxProps {
  label: string;
  value: number;
}

export const StatCard = (props: StatCardProps) => {
  const { label, value, sx, ...boxProps } = props;

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        p: 1.5,
        minWidth: 160,
        ...sx,
      }}
      {...boxProps}
    >
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="h6">{value}</Typography>
    </Box>
  );
};
